import * as React from "react";
import { SVGProps } from "react";
const SvgSend = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m26.984 14.269-20.7-10.1c-.6-.3-1.3-.2-1.7.3-.4.5-.6 1.1-.3 1.7l5 9.9-5.1 9.8c-.3.6-.2 1.2.3 1.7s1.2.6 1.7.3l20.7-10.1c.7-.3 1.1-1 1.1-1.8s-.3-1.3-1-1.7Zm-20.3-7.6 17.3 8.4h-12.9l-4.4-8.4Zm4.4 10.4h12.9l-17.2 8.4 4.3-8.4Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSend;
